import { getProjectEntry, deleteProjectEntry, updateProjectEntry } from "../../../data/models/project.model";
import { ProjectApplication } from "../../../data/classes/project.class";
import { bus } from "@/main";
import VueCookies from "vue-cookies";



export default {
	name: "ProjectPage",
	data() {
		return {
			isReady: false,
			content: null,
			language: this.$route.params.lang,
			projectModal: false,
			deleteModal: false,
			user: null,
			form: {
				title: null,
				course: null,
				courseEng: null,
				class: null,
				classEng: null,
				professors: null,
				students: null,
				objective: null,
				objectiveEng: null,
				technology: null,
				technologyEng: null,
				keywords: [],
				concept: null,
				conceptEng: null,
				images: [],
				schools: []
			},
			disableKeywords: false,
			keywords: [
				{ label: "Comunicação", slug: 'comunication' },
				{ label: "Mix Media", slug: 'mix_media' },
				{ label: "Design Estratégico", slug: 'design_strategy' },
				{ label: "Gestão do Design", slug: 'design_management' },
				{ label: "Editorial", slug: 'editorial' },
				{ label: "Ilustração", slug: 'illustration' },
				{ label: "Industrial", slug: 'industrial' },
				{ label: "Produto", slug: 'product' },
				{ label: "Design Social", slug: 'social_design' },
				{ label: "Joalharia", slug: 'jewelry' },
				{ label: "Software", slug: 'software' },
				{ label: "Packaging", slug: 'packaging' },
				{ label: "Set Design", slug: 'set_design' },
				{ label: "Tipografia", slug: 'typography' },
				{ label: "Web Design", slug: 'web_design' },
				{ label: "Interação", slug: 'interaction' },
				{ label: "Food Design", slug: 'food_design' },
				{ label: "Design de Ambientes", slug: 'ambient_design' },
				{ label: "Craft Design", slug: 'craft_design' },
				{ label: "Infodesign", slug: 'info_design' },
				{ label: "Design de Moda", slug: 'fashion_design' },
			],
		}
	},
	created() {
		this.getContent();
		bus.$on(["uploadImage", "deleteImage"], (data) => {
			// console.log("Change Image! Remain:", data.images);
			// console.log("Project:", this.content.title);
			// console.log("FileBlock Passed ID:", data.id, "ProjectID:", this.content.id)
			if( data.id === this.content.id ) {
				this.form.images = data.images;
				this.updateProject(this.content.id);
			}
		})
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	watch: {
		"$route": function () {
			language: this.$route.params.lang
		}
	},
	methods: {
		getContent() {
			this.user = VueCookies.get("user");
			getProjectEntry(this.$route.params.project, "slug", 2).then(
				content => {
					this.content = content;
					this.isReady = true;
					this.form = content;
				}
			);
		},
		deleteProject(id) {
			deleteProjectEntry(id).then( response => {
				// console.log("Response", response)
				bus.$emit('notification', "🗑 Projeto Eliminado!")
			});
			this.$router.push({ path: `/projects/` });
			bus.$emit('projectDeleted');
		},
		updateProject(id, close) {
			let body = new ProjectApplication(this.form);
			updateProjectEntry(id, body).then( response => {
				bus.$emit('notification', "👍 Projeto Atualizado!")
			});
			if(close) {
				this.projectModal = false;
			}
		},
		evalKeyword(value) {
			if (this.content.keywords && this.content.keywords.length >= 3)
				this.disableKeywords = true;
			else
				this.disableKeywords = false;

			if (this.content.keywords && this.content.keywords.includes(value))
				return true;
			else
				return false;
		},
		toggleKeyword(value) {
			let index = this.form.keywords.indexOf(value);
			if (index >= 0)
				this.form.keywords.splice(index, 1);
			else if (!this.disableKeywords) {
				this.form.keywords.push(value);
			}
		},
		sendImages(images) {
			setTimeout(() => {
				bus.$emit("receivedImages", images);
			}, 500);
		}
	},
}



// WEBPACK FOOTER //
// ./src/components/pages/project/project.page.js